import AxiosInstance from "./api";

export const JournalVoucher7Service = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/journal-voucher-7s/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/journal-voucher-7s/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/journal-voucher-7s", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/journal-voucher-7s/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/journal-voucher-7s/" + id);
  },

  preview: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/journal-voucher-7s/preview", {
      params: query,
    });
  },

  sync: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.post("/private/journal-voucher-7s/sync", null, {
      params: query,
    });
  },
};
